import React from 'react';
import { HomecardLabel, Checked } from '@spotahome/ui-library';
import { trans } from '@spotahome/bff/client';

export const generateHomeCardLabels = checked => () =>
  checked ? (
    <HomecardLabel
      renderIcon={() => <Checked />}
      renderContent={() => trans('homecard.label.checked')}
      className="label--checked"
    />
  ) : null;

export default generateHomeCardLabels;
